import env from '@config/env';
import * as Sentry from '@sentry/react';
import posthog from 'posthog-js';
import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

Sentry.init({
  dsn: 'https://94cd6303ac4d722e5a930188eab4d2a7@o4505871895560192.ingest.us.sentry.io/4506956656279552',
  integrations: [
    Sentry.browserTracingIntegration(),
    // See docs for support of different versions of variation of react router
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration(),
    Sentry.browserProfilingIntegration(),
    posthog.sentryIntegration({
      organization: 'cartedo-app',
      projectId: 4506956656279552,
      severityAllowList: ['error', 'warning'],
    }),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  tracePropagationTargets: [/^\//, /^https:\/\/api\.cartedo\.com\/api/],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enabled: env.PROD,
  environment: env.ROLLBAR_ENV,
  profilesSampleRate: 1.0,
  ignoreErrors: [
    /Request failed with status code 401/i, // This is a common error that happens when the user is not logged in or the session has expired
    /pdfjs/i, // This is pdfjs error
    /acsbapp.com/i, // This is acsbapp.com error
    /pdfjs-dist/i, // This is pdfjs-dist error
  ],
});
